import React from 'react'

var EventFormFieldDisplay = React.createClass({
  propTypes: {
    label: React.PropTypes.string,
    display_text: React.PropTypes.string,
    name: React.PropTypes.string,
  },
  render: function() {
    const { label, display_text, name } = this.props;
    return(
      <div className="form-group">
        <label className="col-lg-12">{label}</label>
        <p className="col-lg-12">{ display_text }</p>
      </div>
    );
  }
});

export default EventFormFieldDisplay;


// WEBPACK FOOTER //
// ./src/components/event_form_field_display.js